import React, { useEffect, useRef } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { useProto } from '../../contexts/PrototypeContext';
import { RegistrationHeader } from './RegistrationHeader';
import { VolunteerInfoStep } from './VolunteerInfoStep';
import { CartStep } from './CartStep';
import { ConfirmationStep } from './ConfirmationStep';
export function RegistrationFlow({
  device
}: {
  device: 'mobile' | 'desktop';
}) {
  const {
    state
  } = useProto();
  const scrollRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    scrollRef.current?.scrollTo({
      top: 0
    });
  }, [state.step, state.activeScenario]);
  return <div className="flex h-full flex-col bg-white" data-id="element-303" data-mp="agpn976un6yu">
      <RegistrationHeader device={device} data-id="element-304" data-mp="6euly2ox4tl2" />
      <div ref={scrollRef} className="min-h-0 flex-1 overflow-y-auto" data-id="element-305" data-mp="6g5ueftb6pii">
        <AnimatePresence mode="wait" initial={false} data-id="element-306" data-mp="1frk0r48j3hb">
          <motion.main key={state.step} initial={{
          opacity: 0,
          x: 8
        }} animate={{
          opacity: 1,
          x: 0
        }} exit={{
          opacity: 0,
          x: -8
        }} transition={{
          duration: 0.18,
          ease: [0.23, 1, 0.32, 1]
        }} data-id="element-307" data-mp="1hceyhugoofp">
            {state.step === 'volunteer' && <VolunteerInfoStep device={device} data-id="element-308" data-mp="lf4dnurfslmc" />}
            {state.step === 'cart' && <CartStep device={device} data-id="element-309" data-mp="7n6cc63yvu0q" />}
            {state.step === 'confirmed' && <ConfirmationStep data-id="element-310" data-mp="cjwsetfrupm5" />}
          </motion.main>
        </AnimatePresence>
      </div>
    </div>;
}